import React from 'react';
import { useCurrencyContext } from '../../contexts/CurrencyContext';
import { CURRENCY_META } from '../../store/slices/currencySlice';

interface CurrencyBadgeProps {
  className?: string;
}

/**
 * Small badge displayed in the page header showing the user's active currency.
 * e.g. shows "EUR" when user has selected Euro.
 */
const CurrencyBadge: React.FC<CurrencyBadgeProps> = ({ className = '' }) => {
  const { displayCurrency: currency } = useCurrencyContext();
  const { symbol } = CURRENCY_META[currency];

  if (currency === 'USD') {
    // Default — no need to show a badge when USD is active
    return null;
  }

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium font-mono
        bg-blue-500/10 text-blue-400 border border-blue-500/20 ${className}`}
      title={`Displaying values in ${currency}`}
    >
      <span aria-hidden="true">{symbol}</span>
      {currency}
    </span>
  );
};

export default CurrencyBadge;
